<svg width="0" height="0" style="display: none">
	<symbol
		version="1.1"
		id="logo"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 1412.6 362.1"
		style="enable-background: new 0 0 1412.6 362.1"
		xml:space="preserve">
		<path
			class="logo-svg-color"
			d="M243.9,265.9c-13.3,3.3-28.8,6.1-42.9,6.1c-48.5,0-70.2-16.3-70.2-90.9s26-92.7,72.7-92.7
c13.8,0,27.8,2,40.3,5.6l-4.1,26c-11-3.1-22.5-4.8-33.4-4.8c-28.6,0-40.8,8.9-40.8,64.8c0,56.2,11.7,65.1,40.8,65.1
c10.7,0,21.9-2,33.4-5.4L243.9,265.9z" />
		<path
			class="logo-svg-color"
			d="M448.6,91.5h53.1c44.7,0,62.8,9.4,62.8,51c0,40.8-18.6,57.2-65.3,57.2h-16.1v69.2h-34.5V91.5z M500.2,173.7
c21.2,0,30.1-8.9,30.1-29.9c0-20.9-7.6-26.3-29.4-26.3h-17.9v56.2H500.2z" />
		<path
			class="logo-svg-color"
			d="M622,202.8L566.6,91.5h34.7l23.5,43.9c6.9,12.5,10.5,21.4,15.6,33.4h0.8c5.1-13,8.4-21.4,14.3-33.4l22.2-43.9
h34.4l-56.2,111.5v65.9H622V202.8z" />
		<path class="logo-svg-color" d="M730.2,91.5h34.4v149.6h63.3v27.8h-97.8V91.5z" />
		<path class="logo-svg-color" d="M849.1,91.5H951v26.8h-67.4V165h62.5v26.3h-62.5v50.8H951v26.8H849.1V91.5z" />
		<path
			class="logo-svg-color"
			d="M1017.1,91.5h51.3l52.1,177.4h-36l-13-44.7h-59l-13,44.7h-33.7L1017.1,91.5z M1065.8,198l-12.5-44.4
c-4.4-14-7.7-26.8-11.5-40.6h-0.2c-3.8,14.3-7.1,27.1-11.5,41.6l-12.2,43.4H1065.8z" />
		<path
			class="logo-svg-color"
			d="M1142.2,91.5h34.4v84.2l53.6-84.2h39.6l-57.9,85.5l61,91.9h-40.6l-55.6-86.8v86.8h-34.4V91.5z" />
		<path
			class="logo-svg-color"
			d="M1285.9,240.1c14,3.6,27.3,5.9,42.9,5.9c22.7,0,32.9-7.9,32.9-22c0-13.3-6.6-17.9-37-33.4
c-33.4-17.1-44.4-27.1-44.4-53.9c0-29.1,18.9-48.2,64.1-48.2c15.6,0,28.8,2.3,39.8,5.4l-3.6,25.8c-11.5-3.1-21.7-5.1-36.8-5.1
c-21.9,0-31.4,7.1-31.4,19.4c0,12,6.9,16.8,36,31.6c35.7,18.6,45.7,27.6,45.7,54.4c0,32.2-20.2,52.1-65.9,52.1
c-15.8,0-30.9-2.3-45.7-6.1L1285.9,240.1z" />
		<defs>
			<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="37.3" y="27.1" width="313.9" height="313.9">
				<feFlood style="flood-color: white; flood-opacity: 1" result="back" />
				<feBlend in="SourceGraphic" in2="back" mode="normal" />
			</filter>
		</defs>
		<mask maskUnits="userSpaceOnUse" x="37.3" y="27.1" width="313.9" height="313.9" id="SVGID_1_"></mask>
		<g class="st2">
			<defs>
				<linearGradient
					id="SVGID_2_"
					gradientUnits="userSpaceOnUse"
					x1="194.2911"
					y1="495.9138"
					x2="194.2911"
					y2="-125.1785">
					<stop offset="0.2141" style="stop-color: #3f97f5" />
					<stop offset="0.8297" style="stop-color: #3fa9f5" />
				</linearGradient>
			</defs>
			<path
				class="logo-svg-copyleaks-color"
				d="M194.3,341c-86.5,0-157-70.4-157-157s70.4-157,157-157s157,70.4,157,157S280.8,341,194.3,341z M194.3,62.1
c-67.2,0-122,54.7-122,122c0,67.3,54.7,122,122,122s122-54.7,122-122C316.3,116.8,261.5,62.1,194.3,62.1z" />
		</g>
		<path
			class="logo-svg-color"
			d="M345.8,88c-9.4,0-18,0.7-25.6,2.4c5.8,7.8,10.9,16.1,15.2,24.9c2.8-0.4,5.8-0.6,9.1-0.6
c26,0,37.3,10.7,37.3,65.6s-11.2,65.3-37.3,65.3c-25.8,0-36.7-10.7-36.7-65.6c0-14.3,0.7-25.6,2.3-34.4
c-4.5-13.6-11.4-26.2-20.1-37.2c-11.1,14.1-16.9,36.9-16.9,72.7c0,75.3,23.5,91.4,70.4,91.4c47,0,72.8-17.9,72.8-93.2
S392.8,88,345.8,88z" />
	</symbol>
</svg>

<span>{{ translations?.SHARED?.POWERED_BY || 'Powered by' }}</span>

<a
	aria-label="Open Copyleaks website."
	title="Powered By Copyleaks.com"
	href="https://copyleaks.com"
	target="_blank"
	[class]="'a-' + directionService.dir">
	<!-- <img [src]="logo | safe: 'url'"
			 alt="Powered by Copyleaks" /> -->
	<svg style="margin-top: 5px" height="84" width="103" alt="Powered by Copyleaks">
		<use xlink:href="#logo"></use>
	</svg>
</a>
